export function hash(str: string): number {
  const bitwiseShift = 5
  let hash = 0
  let i
  let chr

  if (str.length === 0) {
    return hash
  }

  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i)
    hash = (hash << bitwiseShift) - hash + chr
    hash |= 0
  }

  return hash
}

/**
 * This uses window.crypto.subtle to SHA-256 hash a string.
 * @param str - a string to hash
 * @returns a hashed string
 */
export async function sha256HashString(str: string): Promise<string> {
  const msgUint8 = new TextEncoder().encode(str);                               // encode as (utf-8) Uint8Array
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);           // hash the message
  const hashArray = Array.from(new Uint8Array(hashBuffer));                     // convert buffer to byte array
  // eslint-disable-next-line no-magic-numbers
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
  return hashHex;
}
